// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__25Hn8","empty":"ModalGraph_empty__11Gs1"};